module.exports = __webpack_public_path__ + "Termo_de_Uso_de_Imagem_para_MAIORES.pdf?8487652947c5e4da0831fa17d1ecdf66";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resources/Termo_de_Uso_de_Imagem_para_MAIORES.pdf
// module id = 88
// module chunks = 0